import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { history } from './utils/history';
import NoMatchPage from './pages/NoMatchPage';
import MailVerifyPage from './pages/MailVerifyPage';
import InquaryPage from './pages/InquaryPage';
import PassForgotPage from './pages/PassForgotPage';
import PrivateAnlagenPage from './pages/customer/AnlagenPage';
import LogoutPage from './pages/LogoutPage';
import TimeLinePage from './pages/customer/TimeLinePage';
import SupportPage from './pages/SupportPage';
import HomePage from './pages/HomePage';
import { AuthProvider } from './context/AuthContext';
import HwGuard from './guards/HwGuard';
import PrivateGuard from './guards/PrivateGuard';
import DashboardPage from './pages/hw/DashboardPage';
import ScanPage from './pages/hw/ScanPage';
import BuildingsPage from './pages/hw/BuildingsPage';
import ElvPage from './pages/private/ElvPage';
import ElvDetailPage from './pages/private/ElvDetailPage';
import InvoicePage from './pages/hw/InvoicePage';
import ArchivePage from './pages/hw/ArchivePage';
import LoggedPage from './pages/LoggedPage';
import BuildingAnlagenPage from './pages/hw/BuildingAnlagenPage';
import ReactGA from "react-ga4";
import NewTicketPage from './pages/NewTicketPage';
import HwTimelinePage from './pages/hw/HwTimelinePage';
import PromoVideoPage from './pages/PromoVideoPage';
import NewBuildingPage from './pages/hw/NewBuildingPage';
import FaqPage from './pages/private/FaqPage';
import PrivateDashboardPage from './pages/private/PrivateDashboardPage';
import VollmachtSignPage from './pages/VollmachtSignPage';
import MissingDocumentUnsubPage from './pages/MissingDocumentUnsubPage';
import SettingsPage from './pages/private/SettingsPage';
import DownloadPageV2 from './pages/private/DownloadPageV2';
import RegistrationPage from './pages/RegistrationPage';
import HwLayout from './layout/HwLayout';
import { SidebarProvider } from './context/SidebarContext';
import PrivateLayout from './layout/PrivateLayout';
import DownloadDocumentPage from './pages/customer/DownloadDocumentPage';
import NotificationsPage from './pages/private/NotificationsPage';
import TimelinePage from './pages/test/TimelinePage';
import AnlageAnmeldePage from './pages/customer/AnlageAnmeldePage';
import { useEffect } from 'react';
import { flushQueue } from './utils/error/queue';
import EmbededRegisterPage from './pages/embeded/EmbededRegisterPage';

// App
function App() {
  
  // Google Analytics
  if (window.location.hostname === 'mein.energiepool.at') {
	  const TRACKING_ID = "G-LWLH6PYV7Y";
	  ReactGA.initialize(TRACKING_ID);
  }

  history.navigate = useNavigate();
  history.location = useLocation();

  //const { authenticated, user } = useAuthState();
  //const dispatch = useAuthDispatch();


  // flush error report queue
  useEffect(() => {
    flushQueue();

    window.addEventListener("online", flushQueue);
    return () => window.removeEventListener("online", flushQueue);
  }, [])


  return (
      <SidebarProvider>
        <Routes>
          <Route path='/'>
            <Route index element={<HomePage />} />
            <Route path='next/:next' element={<HomePage />} />
            <Route path="qr/:qr" element={<HomePage />} />
            <Route path='willkommen/' element={<HomePage />} />
            <Route path='jahresabrechnung/:token' element={<HomePage />} />
            <Route path='login/:next' element={<HomePage />} />
            <Route path='logged/' element={<LoggedPage />} />
            <Route path='password/reset/:token' element={<PassForgotPage />} />
            <Route path='mail/confirmation/:token' element={<MailVerifyPage />} />
            <Route path='mail/registration/:token' element={<MailVerifyPage />} />
            <Route path='registration/' element={<RegistrationPage />} />
            <Route path='registration/:param' element={<InquaryPage />} />
            <Route path="vollmacht/" element={<VollmachtSignPage />} />
            <Route path="unsubscribe/:token" element={<MissingDocumentUnsubPage />} />
            <Route path='embeded/register/' element={<EmbededRegisterPage />} />
          </Route>

          <Route path='/dashboard/' element={<PrivateLayout />}>
            <Route index element={<PrivateGuard Component={PrivateDashboardPage} />} />
            <Route path='zeitverlauf/' element={<PrivateGuard Component={TimeLinePage} />} />
            <Route path='zeitverlaufV2/' element={<PrivateGuard Component={TimelinePage} />} />
            <Route path='zeitverlauf/:anlage' element={<PrivateGuard Component={TimeLinePage} />} />
            <Route path='anlagen/' element={<PrivateGuard Component={PrivateAnlagenPage} />} />
            <Route path='anlagen/anmelden/' element={<PrivateGuard Component={AnlageAnmeldePage} />} />
            <Route path='energieliefervertraege/:elv_id' element={<PrivateGuard Component={ElvDetailPage}/>}/>
            <Route path='support/' element={<PrivateGuard Component={SupportPage} />} />
            <Route path='support/:ticket_id' element={<PrivateGuard Component={SupportPage} />} />
            <Route path='support/neu/' element={<PrivateGuard Component={NewTicketPage}/>} />
            <Route path='support/neu/:param' element={<PrivateGuard Component={NewTicketPage}/>} />
            <Route path='einstellungen/' element={<PrivateGuard Component={SettingsPage} />} />
            <Route path='news/' element={<PrivateGuard Component={NotificationsPage} />} />
            <Route path="news/details/:notification_id/" element={<PrivateGuard Component={NotificationsPage} />} />
            <Route path='faq/' element={<PrivateGuard Component={FaqPage} />} />
            <Route path="dokumente/" element={<DownloadDocumentPage />} />
            <Route path='vollmacht/:token' element={<VollmachtSignPage />} />
          </Route>

          <Route path={'/hw/dashboard/'} element={<HwLayout />}>
            <Route index element={<HwGuard Component={DashboardPage} />} />
            <Route path='gebaeude/' element={<HwGuard Component={BuildingsPage} />} />
            <Route path='gebaeude/anlagen/:building_id/' element={<HwGuard Component={BuildingAnlagenPage} />} />
            <Route path='gebaeude/anlagen/:building_id/:energo_nr/' element={<HwGuard Component={BuildingAnlagenPage} />} />
            <Route path='gebaeude/dokumente/:building_id' element={<HwGuard Component={InvoicePage} />} />
            <Route path='gebaeude/neu/' element={<HwGuard Component={NewBuildingPage} />} />
            <Route path='einstellungen/' element={<HwGuard Component={SettingsPage} />} />
            <Route path='download/' element={<HwGuard Component={DownloadPageV2} />} />
            <Route path="archive/" element={<HwGuard Component={ArchivePage} />} />
            <Route path="benachrichtigung/" element={<HwGuard Component={NotificationsPage} /> } />
            <Route path="benachrichtigung/details/:notification_id/" element={<HwGuard Component={NotificationsPage} />} />
            <Route path="benachrichtigung/details/:notification_id/:secret" element={<HwGuard Component={NotificationsPage} />} />
            <Route path='faq/' element={<HwGuard Component={FaqPage} />} />


            <Route path="energieliefervertraege/" element={<HwGuard Component={ElvPage} />} />
            <Route path="energieliefervertraege/:elv_id" element={<HwGuard Component={ElvDetailPage} />} />
            <Route path='energieliefervertraege/gebaeude/:buildingId' element={<HwGuard Component={ElvPage} />} />
            <Route path='energieliefervertraege/zeitverlauf/:building_id' element={<HwGuard Component={HwTimelinePage} />} />
            <Route path='energieliefervertraege/zeitverlauf/:building_id/:anlage_id' element={<HwGuard Component={HwTimelinePage} />} />
            

            <Route path='scannen/' element={<HwGuard Component={ScanPage} />} />
            <Route path='support/' element={<HwGuard Component={SupportPage} />} /> 
            <Route path='support/:ticket_id' element={<HwGuard Component={SupportPage} />} /> 
            <Route path='support/neu/' element={<HwGuard Component={NewTicketPage}/>} />
            <Route path='support/neu/:param' element={<HwGuard Component={NewTicketPage}/>} />
          </Route>
          
          <Route path='promo/' element={<PromoVideoPage />} />
          <Route path='logout/' element={<LogoutPage />} />
          <Route path='*' element={<NoMatchPage />} />
        </Routes>
      </SidebarProvider>
  );
}

export default App;